export default "__VITE_ASSET__2SbwT05___"